<template>
  <div class="content_box">
    <div class="userManage" id="ManageTable">
      <div class="userManage_header">
        <div class="userManage_logo">
          <img src="@/assets/imgs/icon/user_logo.png" alt />
        </div>
        <h3>数据导入</h3>
      </div>
      <div class="userManage_form">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="报表名称">
            <el-select v-model="formInline.name" placeholder="请选择" clearable>
              <el-option
                label="各区县规上工业经济运行情况"
                value="各区县规上工业经济运行情况"
              ></el-option>
              <el-option
                label="各行业规模以上工业经济情况"
                value="各行业规模以上工业经济情况"
              ></el-option>
              <el-option
                label="规模以上工业主要产品产量"
                value="规模以上工业主要产品产量"
              ></el-option>
              <el-option
                label="工业经济运行先行指标"
                value="工业经济运行先行指标"
              ></el-option>
              <el-option
                label="各区县工业与技改投资情况"
                value="各区县工业与技改投资情况"
              ></el-option>
              <el-option
                label="全县工业投资情况"
                value="全县工业投资情况"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="填报日期">
            <el-date-picker
              v-model="formInline.date_range"
              type="month"
              clearable
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit"
              class="bg5584FF formBotton"
              >查询</el-button
            >
            <el-button type="info" @click="reset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item style="float: right">
            <el-button
              type="primary"
              @click="handleUpload"
              icon="el-icon-upload2"
              >上传</el-button
            >
            <el-button
              type="primary"
              @click="handleDownload"
              icon="el-icon-download"
              >下载</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格数据 -->
      <el-table
        border
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="name" label="报表名称">
          <template slot-scope="scope">
            <span class="detail" @click="handleDetail(scope.row)">{{
              scope.row.name
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="date_range"
          label="填报期"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="toDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pageBox">
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pageSizes="[20, 30, 50, 100]"
          layout="sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="数据导入"
        :visible.sync="uploadDialogVisible"
        class="titleChange"
        width="30%"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        @closed="handleClose"
        v-loading="uploadloading"
      >
        <div class="addUser">
          <el-form
            :model="uploadRuleForm"
            :rules="rules"
            ref="uploadRuleForm"
            label-width="135px"
            class="demo-RuleForm"
            size="small"
          >
            <el-form-item label="选择上传文件：">
              <el-upload
                class="upload-demo"
                action
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-change="onChange"
                :multiple="false"
                :limit="1"
                :auto-upload="false"
                :on-exceed="handleExceed"
                :file-list="fileList"
              >
                <el-button size="mini" type="primary">上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="报表名称：" prop="name">
              <el-select
                v-model="uploadRuleForm.name"
                clearable
                placeholder="请选择"
              >
                <el-option
                  label="各区县规上工业经济运行情况"
                  value="各区县规上工业经济运行情况"
                ></el-option>
                <el-option
                  label="各行业规模以上工业经济情况"
                  value="各行业规模以上工业经济情况"
                ></el-option>
                <el-option
                  label="规模以上工业主要产品产量"
                  value="规模以上工业主要产品产量"
                ></el-option>
                <el-option
                  label="工业经济运行先行指标"
                  value="工业经济运行先行指标"
                ></el-option>
                <el-option
                  label="各区县工业与技改投资情况"
                  value="各区县工业与技改投资情况"
                ></el-option>
                <el-option
                  label="全县工业投资情况"
                  value="全县工业投资情况"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="填报期：" prop="date_range">
              <el-date-picker
                v-model="uploadRuleForm.date_range"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                :picker-options="dateDisabled"
                clearable
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <div class="btnBox">
            <el-button type="primary" @click="upload('uploadRuleForm')"
              >导入</el-button
            >
            <el-button @click="uploadDialogVisible = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="下载EXCEL模版"
        :visible.sync="downloadDialogVisible"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
        :destroy-on-close="true"
      >
        <div class="addUser">
          <el-table :data="downloadData" style="width: 100%">
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="name" label="报表名称"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  class="bg5584FF"
                  @click="downLoadExcel(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="30%"
        center
      >
        <span>删除后不可恢复，确认删除？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="del()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      pageSize: 20,
      deleteDialogVisible: false,
      delRow: {},
      formInline: {
        //查询对象
        name: "各区县规上工业经济运行情况",
        date_range: "",
      },
      tableData: [], //表格数组
      downloadData: [
        {
          name: "各区县规上工业经济运行情况",
        },
        {
          name: "各行业规模以上工业经济情况",
        },
        {
          name: "规模以上工业主要产品产量",
        },
        {
          name: "工业经济运行先行指标",
        },
        {
          name: "各区县工业与技改投资情况",
        },
        {
          name: "全县工业投资情况",
        },
      ], //下载
      pageNum: 1,
      total: 0, //表格总数
      loading: false,
      currentPage: 1,
      uploadloading: false,
      uploadDialogVisible: false,
      downloadDialogVisible: false,
      fileList: [],
      uploadRuleForm: {
        //上传
        date_range: "",
        name: "",
        fileList: [],
      },
      rules: {
        //表单验证规则
        name: [{ required: true, message: "请选择报表", trigger: "blur" }],
        date_range: [
          { required: true, message: "请选择填报期", trigger: "blur" },
        ],
      },
      dateDisabled: {},
    };
  },
  created() {
    this.getdata(this.pageNum);
    this.dateDisabled.disabledDate = function (time) {
      return time.getTime() > Date.now();
    };
  },
  methods: {
    getdata(pageNum) {
      this.loading = true;
      this.$axios
        .get("/business/data-import/page", {
          params: {
            pageNum: pageNum,
            pageSize: this.pageSize,
            name: this.formInline.name,
            date_range: this.formInline.date_range,
          },
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    onSubmit() {
      //查询
      this.getdata(this.pageNum);
    },
    toDel(row) {
      this.deleteDialogVisible = true;
      this.delRow = row;
    },
    reset() {
      //重置
      this.formInline = {
        //查询对象
        name: "各区县规上工业经济运行情况",
        date_range: "",
      };
      this.getdata(this.pageNum);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getdata(1);
    },
    handleCurrentChange(val) {
      //跳转页
      this.getdata(val);
    },
    handleUpload() {
      this.uploadDialogVisible = true;
    },
    handleDownload() {
      this.downloadDialogVisible = true;
    },
    handleClose() {
      this.$refs.uploadRuleForm.resetFields();
      this.getdata(1);
      this.fileList = [];
      this.uploadRuleForm = {
        //上传
        date_range: "",
        name: "",
        fileList: [],
      };
    },
    upload(formName) {
      const self = this;
      //修改提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadloading = true;
          const formdata = new FormData();
          formdata.append("file", self.fileList[0].raw);
          formdata.append("name", self.uploadRuleForm.name);
          formdata.append("date_range", self.uploadRuleForm.date_range);
          self.$axios
            .post("/business/data-import/upload", formdata)
            .then((res) => {
              self.fileList = [];
              Message.success("上传成功");
              self.uploadloading = false;
              self.uploadDialogVisible = false;
            })
            .catch((err) => {
              self.uploadloading = false;
              console.log("error", err);
            });
        } else {
          // Message.error("请完善表单信息");
          return false;
        }
      });
    },
    del() {
      const self = this;
      self.deleteDialogVisible = false;
      //修改提交
      self.$axios
        .delete(
          `/business/data-import/del?id=${self.delRow.id}&name=${self.delRow.name}`
        )
        .then((res) => {
          self.getdata(1);
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    downLoadExcel(row) {
      window.open(
        window.location.origin +
          "/api/business/data-import/download-template?name=" +
          row.name
      );
    },
    handleDetail(row) {
      var _this = this;
      var originUrl =
        window.location.origin +
        "/api/business/data-import/download?name=" +
        encodeURIComponent(row.name) +
        "&id=" +
        row.id +
        "&fullfilename=" +
        row.id +
        ".xls";

      _this.$axios
        .get(`/system/config/selectRegionAndVersion`)
        .then((result) => {
          if (result.data.data.region && result.data.data.version) {
            _this.$axios
              .get(
                `/system/config/selectConfigByRegionAndKeyAndVersion?region=${result.data.data.region}&key=onlinePreview&version=${result.data.data.version}`
              )
              .then((result) => {
                var url = result.data.data.value;
                console.log(url);
                window.open(
                  `${url}onlinePreview?url=` + encodeURIComponent(originUrl)
                );
              });
          } else {
            return;
          }
        });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onChange(file, fileList) {
      console.log(file);
      this.fileList = fileList;
    },
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.userManage {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .userManage_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .userManage_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .userManage_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }
  .userManage_add_user {
    margin-bottom: 20px;
  }
  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}

.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>